import type { StudentApiResponse } from '@/domains/students/student.entity';
import type { StudentRepository } from '@/domains/students/student.repository';

/**
 * Use Case para obtener lista completa de estudiantes desde el repositorio
 * Cumple ISP: Interface Segregation Principle
 * Cumple DIP: Dependency Inversion Principle (depende de abstracción StudentRepository)
 *
 * Responsabilidades:
 * - Obtener datos completos de todos los estudiantes desde la fuente de datos
 * - Actuar como intermediario entre la capa de dominio y la infraestructura
 *
 * Refactorizado para usar StudentRepository (interfaz granular)
 * Los datos incluyen información académica, de riesgo e indicadores por estudiante
 */
export class GetAllStudentUseCase {
  private studentRepository: StudentRepository;

  /**
   * Inicializa el UseCase con el repositorio de estudiantes
   * @param studentRepository - Repositorio que implementa la interfaz StudentRepository
   */
  constructor(studentRepository: StudentRepository) {
    this.studentRepository = studentRepository;
  }

  /**
   * Ejecuta la obtención de la lista completa de estudiantes
   * @returns Promesa con la respuesta de la API conteniendo todos los estudiantes
   * @throws Error si falla la comunicación con el repositorio
   */
  async execute(): Promise<StudentApiResponse> {
    return await this.studentRepository.getAllStudents();
  }
}
